/**
 * Messaggi per i codici `?auth_error=` con cui auth-service rimanda al frontend
 * dopo un login Google rifiutato (WP-03: allowlist al primo login).
 */
export const ACCOUNT_NOT_ENABLED_MESSAGE = 'Account non abilitato: chiedi un invito alla tua scuola';

const AUTH_ERROR_MESSAGES: Record<string, string> = {
  account_not_enabled: ACCOUNT_NOT_ENABLED_MESSAGE,
};

/** Messaggio utente per un codice noto, altrimenti null. */
export function getAuthErrorMessage(code: string | null | undefined): string | null {
  if (!code) return null;
  return Object.prototype.hasOwnProperty.call(AUTH_ERROR_MESSAGES, code) ? AUTH_ERROR_MESSAGES[code] : null;
}

/**
 * Legge `?auth_error=` dall'URL corrente, restituisce il messaggio italiano per i codici noti
 * (null altrimenti) e rimuove il parametro dall'URL con history.replaceState (anche se sconosciuto).
 * Sicura fuori dal browser e se history/location non sono disponibili.
 */
export function readAuthError(): string | null {
  try {
    if (typeof window === 'undefined') return null;
    const url = new URL(window.location.href);
    if (!url.searchParams.has('auth_error')) return null;
    const message = getAuthErrorMessage(url.searchParams.get('auth_error'));
    url.searchParams.delete('auth_error');
    try {
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    } catch {
      /* ignora */
    }
    return message;
  } catch {
    return null;
  }
}
